import OutsideClickAlerter from '@components/OutsideClickAlerter/OutsideClickAlerter'

export default function BiddingHistory({
  bidHistory,
  setShowBidHistory,
  twcss,
}: any) {
  return (
    <OutsideClickAlerter callback={() => setShowBidHistory(false)}>
      <div
        className={`absolute w-max max-h-50 overflow-y-auto bg-white border border-bidfta-gray-border rounded-md cursor-default z-10 ${twcss}`}
      >
        <table className="text-xs rounded-md ">
          <thead className="bg-bidfta-green-tabledark">
            <tr className="w-full">
              <th className="text-left pl-2 pr-2 py-1.5">Bidder ID</th>
              <th className="text-left py-2">Bid</th>
              <th className="text-left py-2">{'Date & Time'}</th>
            </tr>
          </thead>
          {bidHistory.map((line: any, i: any) => (
            <tr
              key={`bid-history-line-${i}`}
              className={
                i % 2 === 0 ? 'bg-white' : 'bg-bidfta-green-tablelight'
              }
            >
              <td className="pl-2">{line.bidderId}</td>
              <td className="pr-3 py-1">${line.bidAmount.toFixed(2)}</td>
              <td className="pr-2">
                {`${line.createdDateText.split('-').join('/')} ${
                  line.createdTimeText
                }`}
              </td>
            </tr>
          ))}
        </table>
      </div>
    </OutsideClickAlerter>
  )
}
